import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Logo } from '../common/ui/Logo';
import { AuthMenu } from '../auth/AuthMenu';
import { UserMenu } from '../users/UserMenu';
import { ShoppingCartIcon } from './ShoppingCartIcon';
import { SearchNavbarForm } from '../search/SearchNavbarForm';
import { NotificationsIcon } from '../common/ui/NotificationsIcon';

export const ShopNavbar = ({ user, children }) => {
    const location = useLocation();

    return (
        <header className="border-bottom w-100 p-3 mb-4">
            <nav className="container d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
                <NavLink
                    to="/"
                    className="navbar-brand d-flex align-items-center mb-2 mb-lg-0 text-dark text-decoration-none">
                    <Logo />
                    Gift Shop
                </NavLink>
                <div className="nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0">
                    {children}
                </div>
                {location.pathname !== '/search' && <SearchNavbarForm />}
                <NotificationsIcon />
                <ShoppingCartIcon />
                <div className="text-end">
                    {user != null ? <UserMenu user={user} /> : <AuthMenu />}
                </div>
            </nav>
        </header>
    );
};
